
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import logo from '../../assets/img/Logo_AXIAN.svg';
import { listLanguage } from "../../request/Request";
import "../../assets/css/back-style.css";
import "../../assets/vendor/bootstrap/css/bootstrap.min.css";
import "../../assets/vendor/bootstrap-icons/bootstrap-icons.css";
import "../../assets/vendor/boxicons/css/boxicons.min.css";
import "../../assets/vendor/simple-datatables/style.css";
import "../../assets/css/table-responsive.css";
import "../../assets/vendor/remixicon/remixicon.css";

function Header(props) {

    const [isOpen, setIsOpen] = useState(true);
    const [languages, setLanguages] = useState([]);
    const lesLangues = async () => {
        const reponse = await listLanguage();
        if (reponse.status === 200) {
            setLanguages(reponse.data);
        } else if (reponse.status === 410) {
            localStorage.clear();
            navigate(process.env.REACT_APP_ADMIN_URL+'/');
        }
    }
    const handleClick = () => {
        if (isOpen) {
            document.body.classList.add('toggle-sidebar');
            setIsOpen(false);
        }
        else {
            document.body.classList.remove('toggle-sidebar');
            setIsOpen(true);
        }
    };
    const user = JSON.parse(localStorage.getItem('user'));

    let lang = JSON.parse(localStorage.getItem('lang'));

    const navigate = useNavigate();

    const logout = () => {
        localStorage.clear();
        window.location.href = process.env.REACT_APP_ADMIN_URL + '/';
    };

    const callChangeLanguage = (lang) => {
        localStorage.setItem('lang', JSON.stringify(lang));
        window.location.reload();
    }

    var search = "";
    if (props.search !== undefined) search = props.search;

    var searchFullText = "";
    if (props.searchFullText !== undefined) searchFullText = props.searchFullText;

    useEffect(() => {
        lesLangues();
    }, []);

    let langueList = languages.map((item) => <><li>
        <Link className="dropdown-item d-flex " onClick={() => { callChangeLanguage(item) }}>
            <span>{item.code}</span>
        </Link>
    </li><li>
            <hr className="dropdown-divider" />
        </li></>);

    return (
        <header id="header" className="header fixed-top d-flex align-items-center">
            <div className="d-flex align-items-center justify-content-between">
                <Link to={process.env.REACT_APP_ADMIN_URL+"/dashboard"} className="logo d-flex align-items-center">
                    <img src={logo} alt="" />
                </Link>
                <i className="bi bi-list toggle-sidebar-btn" onClick={handleClick}></i>
            </div>

            <div className="search-bar">
                <form className="search-form d-flex align-items-center" method="GET" action={process.env.REACT_APP_ADMIN_URL+"/global-search"}>
                    <input type="text" defaultValue={search} name="query" placeholder="Rechercher par un mot clé" title="Enter search keyword" required />
                    <button type="submit" title="Search"><i className="bi bi-search"></i></button>
                </form>
            </div>
            <div className="search-bar">
                <form className="search-form d-flex align-items-center" method="GET" action={process.env.REACT_APP_ADMIN_URL+"/fulltext-search"}>
                    <input type="text" defaultValue={searchFullText} name="query" placeholder="Recherche par plusieurs mots clés" title="Entrer plusieurs mots clés séparés par des virgules" required />
                    <button type="submit" title="Search"><i className="bi bi-search"></i></button>
                </form>
            </div>

            <nav className="header-nav-back">
                <ul className="d-flex ">
                    <li className="nav-item dropdown pe-3">
                        {lang !== null ? <Link className="nav-link nav-profile d-flex  pe-0" data-bs-toggle="dropdown">
                            <span className="d-none d-md-block dropdown-toggle ps-2">{lang.code}</span>
                        </Link> : <Link className="nav-link nav-profile d-flex  pe-0" data-bs-toggle="dropdown">
                            <span className="d-none d-md-block dropdown-toggle ps-2">Langue</span>
                        </Link>}
                        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow language">
                            <li>
                                <Link className="dropdown-item d-flex " onClick={() => { callChangeLanguage(null) }}>
                                    <span>Toutes</span>
                                </Link>
                            </li>
                            <li>
                                <hr className="dropdown-divider" />
                            </li>
                            {langueList}
                        </ul>
                    </li>
                </ul>
            </nav>
            <nav className="header-nav-back ms-auto">
                <ul className="d-flex align-items-center">
                    <li className="nav-item d-block d-lg-none">
                        <Link className="nav-link nav-icon search-bar-toggle " >
                            <i className="bi bi-search"></i>
                        </Link>
                    </li>
                    <li className="nav-item dropdown pe-3">
                        <Link className="nav-link nav-profile d-flex align-items-center pe-0"  data-bs-toggle="dropdown">
                            <span className="d-none d-md-block dropdown-toggle ps-2">{user.username}</span>
                        </Link>
                        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                            <li className="dropdown-header">
                                <h6>{user.username}</h6>
                                <span>{user.poste}</span>
                            </li>
                            <li>
                                <hr className="dropdown-divider" />
                            </li>
                            <li>
                                <Link className="dropdown-item d-flex align-items-center" to={process.env.REACT_APP_ADMIN_URL+"/my-profile"}>
                                    <i className="bi bi-person"></i>
                                    <span>Mon profil</span>
                                </Link>
                            </li>
                            <li>
                                <hr className="dropdown-divider" />
                            </li>
                            <li>
                                <Link className="dropdown-item d-flex align-items-center" onClick={logout}>
                                    <i className="bi bi-box-arrow-right"></i>
                                    <span>Déconnecter</span>
                                </Link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </nav>
        </header>
    );
}

export default Header;
